export default __webpack_public_path__ + "static/media/alex5.390fdb42.jpg";